// import adminSettingSlice from '../redux/admin/setting/adminSettingSlice';
import adminSlices from '../features/admin/adminSlices';
import productionManagerSlices from '../features/production-manager/productionManagerSlice';

const roleBasedReducers = {
    "Admin": adminSlices,
    "Production Manager": productionManagerSlices
};

export default roleBasedReducers;